import "../../css/navbar.css";
import "../../css/fonts.css";
import logo from "../../assets/logo.png";
import burger from "../../assets/icons/burger.png";
import { Clickable } from "../clickable.container";
import { useState } from "react";
import { OverlayWindow } from "../overlay";
import { NavbarOverlay } from "./navbar.overlay";
export const NavbarMobile = () => {
  const [isOverlayOpen, setOverlayOpen] = useState(false);

  const openOverlay = () => setOverlayOpen(true);
  const closeOverlay = () => {
    const timer = setTimeout(() => {
      // window.scrollTo(0, 0);
      setOverlayOpen(false);
    }, 1);
  };

  return (
    <div
      style={{
        backgroundColor: isOverlayOpen ? "#282c34" : "",
        position: isOverlayOpen ? "fixed" : "unset",
        display: isOverlayOpen ? "flex" : "unset",
        height: isOverlayOpen ? "100%" : "0",
        width: isOverlayOpen ? "100%" : "0",
        flexDirection: "column",
        top: "0",
        left: "0",
        bottom: "0",
        right: "0",
      }}
    >
      <div className="navbar-mobile">
        <Clickable
          onclick={() => {
            isOverlayOpen ? closeOverlay() : openOverlay();
          }}
          children=""
          backgroundUrl={burger}
          style="navbar-burger"
        />
        <img src={logo} alt="Logo" className="navbar-logo-mobile" />
        <div></div>
      </div>
      {isOverlayOpen && (
        <OverlayWindow
          className="navbar-mobile-overlay"
          children={<NavbarOverlay onClick={closeOverlay} />}
        />
      )}
    </div>
  );
};
